import { Loader } from '../../components/shared/Loader';
import { PageWithAffixedHeader } from '../../shared/PageWithAffixedHeader';
import { Stack } from 'react-bootstrap';
import { useAuthContext } from '../../contexts/AuthContext';
import { useGetAnnouncement } from './useGetAnnouncement';
import { useParams } from 'react-router-dom';

export function Announcement() {
    const { announcementContentGuid } = useParams();
    const { isLoggedIn } = useAuthContext();

    const announcementQuery = useGetAnnouncement(announcementContentGuid ?? '', isLoggedIn);

    if (announcementQuery.isLoading) {
        return <Loader />;
    }

    const announcement = announcementQuery?.data;

    return (
        <>
            <PageWithAffixedHeader headerComponent={<h1>{announcement?.title}</h1>}>
                <Stack gap={2}>
                    <h4>{announcement?.text}</h4>
                    <div dangerouslySetInnerHTML={{ __html: announcement?.pageMarkup ?? '' }} />
                </Stack>
            </PageWithAffixedHeader>
        </>
    );
}
